module.exports = "<p>\n  preco-padrao works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/produto-components/produto/preco-padrao/preco-padrao.component.html
// module id = ../../../../../src/app/components/produto-components/produto/preco-padrao/preco-padrao.component.html
// module chunks = main